import Link from "next/link";

const ContactComponent = () => {
    return (
        <Link
            href="https://zalo.me/0372075935"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-[26px] right-[13px] tab:bottom-12 tab:right-3 w-[130px] h-[52px] tab:w-[146px] tab:h-16 rounded-2xl border border-[#93C5FD] bg-[#1FAEEB] flex-center gap-2 z-50 cursor-pointer"
        >
            <img src="/images/home/contact-zalo.png" alt="Zalo" className="size-10 tab:size-12" />
            <div className="text-sm font-bold leading-5 text-[#F9FAFB]">Liên hệ</div>
        </Link>
    );
};

export default ContactComponent;
